import { TKeys } from './types'

export const ro_ro: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // SCREENS
    // General
    loading: 'Încărcare...',
    // SignIn
    signin_title: 'Conectare',
    signin_redirect_title: 'Verificați identificarea și parola',
    psw_placeholder_redirect: 'Confirmați parola',
    psw_placeholder: 'Parolă',
    email_placeholder: 'Adresă de e-mail',
    language: 'Limbă',
    forgot_password: 'Parolă uitată ?',
    signup_hint: 'Nu aveți un cont? Înscrieți-vă',
    btn_signin: 'Conectare',
    // Intro
    // N-Ary sort
    my_profile: 'Profilul meu',
    btn_submit: 'Confirmare',
    btn_finish: 'Finalizare',
    hint_undo: 'Sunteți sigur că doriți să anulați ultima acțiune?',
    // Global screen
    tip_quit: 'Sunteți sigur că doriți să ieșiți?',
    // State screen
    intro_title: 'Fericirea este cheia succesului',
    intro_body: `Dacă îți place ceea ce faci și echipa cu care lucrezi, vei avea succes în viața profesională.`,
    howto1_title: `Veți vedea 2 declarații. 
    
    Faceți clic pe cea pe care o preferați. 
    
    Va dura doar 12 minute.`,
    howto1_body: 'Vă recomandăm să faceți acest test într-un mediu liniștit. Dacă este necesar, faceți-l mai târziu.',
    award1_title: 'Ați terminat prima etapă, bravo!',
    award1_body: `În partea de sus a paginii următoare, veți găsi ceea ce considerați că este cel mai important în mediul dumneavoastră de lucru ideal. Verificați dacă se potrivește preferințelor dumneavoastră și, dacă este necesar, reordonați ordinele acestor declarații trăgându-le.`,
    award2_title: 'Ați parcurs mai mult de jumătate din drum!',
    award2_body: `Declarațiile cele mai importante se află în partea de sus a paginii următoare. Verificați ordinea și, dacă este necesar, rearanjați-le trăgându-le.`,
    award3_title: 'Felicitări pentru a treia parte',
    award3_body: `Sunteți aproape! Finalizați cu succes răspunzând cu sinceritate!`,
    howto2_title: 'Și acum ultimele întrebări - +/- 2 minute',
    howto2_body: `Puteți ordona din nou declarațiile următoare, de la cea mai importantă (sus) la cea mai puțin importantă (jos). `,
    title_rank: 'În mediul meu de lucru **IDEAL**',
    subtitle_rank_2: 'cel mai important este:',
    subtitle_rank_n: "declarația următoare este + sau - importantă?",
    hint_reorder: 'Reordonați dacă este necesar, de la + la - important',
    hint_overview: 'Faceți clic mai jos pentru a vedea rezumatul',
    hint_profile: 'Preferințele mele actuale',
    hint_place_below: "Introduceți declarația de mai jos",
    title_rank_bucket: 'Toate ultimele comparații',
    subtitle_rank_best: 'De data aceasta, care este CEL MAI important pentru dumneavoastră?',
    subtitle_rank_least: 'Care este CEL MAI PUȚIN important pentru dumneavoastră?',
    subtitle_rank_reorder: 'Reordonați, de la CEL MAI la CEL MAI PUȚIN important',
    title_thanks: 'Vă mulțumim pentru participare!',
    hint_thanks: 'Vă mulțumim! Profilul dumneavoastră a fost trimis corect echipelor noastre.',
    title_error: 'Trimiterea profilului a eșuat',
    hint_error: 'Vă rugăm să încercați din nou mai târziu ...',
    hint_error_validation: 'Eroare de validare a datelor, vă rugăm să încercați din nou mai târziu.',
    hint_error_dup: 'Ați trimis deja un raport anterior.',
    hint_confirm_round: 'Sunteți sigur că doriți să confirmați această ordine?',
    retry_btn: 'Încercați din nou',
    btn_to_overview: 'REZUMAT',
    btn_to_bucket_x: 'GRUP',
    btn_to_params: 'SETĂRI',
    btn_open: 'DESCHIDEȚI',
    btn_start: 'ÎNCEPEȚI',
    btn_confirm: 'CONFIRMAȚI',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'NEXT',
    btn_next_round: 'ETAPA URMĂTOARE',
    // 'btn_prev': 'PREVIOUS',
    btn_prev: '<',
    btn_cancel: 'ANULAȚI',
    // 'btn_back': 'BACK',
    btn_back: '<',
    btn_download: 'Descărcați raportul dumneavoastră',
    btn_quit: 'IEȘIRE',
    // Comparaisons
    pick_best: 'Care este cel mai important pentru dumneavoastră?',
    pick_worst: 'Care este cel mai puțin important pentru dumneavoastră?',
    vs: 'SAU',
    // UI elements
    round: 'Etapă',
    stm: 'Declarație',
    bucket: 'Grup',
    axis_y: "Numărul de Declarații",
    tip_saved: 'Salvat',
    top_scale_hint: 'Cel **MAI** important',
    bottom_scale_hint: 'Cel **MAI PUȚIN** important',
    pick_tip: 'Alegeți !',
    how_to_binary_title: 'Instrucțiuni',
    // values
    samen: 'Colaborare',
    conf: 'Conformitate',
    erken: 'Recunoaștere',
    zorg: 'Îngrijire',
    gelijk: 'Egalitate și diversitate',
    zelfsturing: 'Autonomie',
    macht: 'Putere',
    voorspelbaar: 'Previzibilitate',
    prestatie: 'Performanță',
    zelfontplooi: 'Dezvoltare personală',
    duurzaam: 'Durabilitate',
    integriteit: 'Integritate',
    innovatie: 'Inovație',
    daadkracht: 'Forță',
    //
    no_slug_error: 'Vă rugăm să verificați că linkul este corect sau contactați administratorul / suportul dumneavoastră',
    unknown_error: 'A apărut o eroare, vă rugăm să încercați din nou mai târziu',
    invalid_credentials: 'Combinatie Email / Parolă invalidă',
    // 360:
    // TLTM Scale
    lvl0: 'Vă rugăm selectați',
    lvl1: 'Mult prea puține',
    lvl2: 'Prea puține',
    lvl3: 'Cam prea puțin',
    lvl4: 'Exact suficient',
    lvl5: 'Cam prea',
    lvl6: 'Prea',
    lvl7: 'Prea mult',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Exact suficient',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Vă rugăm selectați',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Niciodată',
    lvlSC10x0: 'Nimic',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Extrem de rău',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Foarte rău',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Rău',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Insuficiente',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Médiocru',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Mediu',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'Bun',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Foarte bon',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Excelent',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Cu siguranță',
    lvlSC10x10: 'Impecabil',
    howto_360_title: `Ca organizație, acordăm o mare importanță valorilor; credem că este esențial să știm ce vă face cu adevărat fericit în mediul dumneavoastră de lucru.`,
    howto_360_body: `Acest chestionar este și va rămâne anonim pentru ierarhia dumneavoastră care va primi doar rezultatele agregate.`,
    picker_360_title_workenv: 'În mediul meu de lucru actual …',
    picker_360_title_leadership: 'Managerul meu direct …',
    nps_title: 'În ce măsură ați recomanda să lucrați aici?',
    comment_title: 'Adaugă un comentariu',
    comment_placeholder: 'Vă mulțumim pentru orice comentariu constructiv (400 caractere)',
    comment_save: 'Salvați și închideți',
    comment_remaining: 'caracter(e) liber(e)',
    howto_workenv_title: 'Împărtășiți acum impresiile dumneavoastră despre mediul de lucru actual',
    howto_workenv_body: `Cum îl percepeți? Gândiți-vă la proceduri, guvernanță, sisteme... Nu ezitați să ne lăsați un comentariu`,
    howto_nps_title: 'Aș recomanda angajatorul dumneavoastră ca loc de muncă?',

    howto_nps_body: 'Pe o scară de la 0 la 10, cât de probabil credeți că ați recomanda angajatorul dumneavoastră ca loc de muncă prietenilor sau familiei?',
   // legacy_v2:
    btn_next_step: 'Următorul',
    to_assign: 'De atribuit',
    least_important: 'Cel mai puțin important',
    moderately_important: 'Moderat de important',
    most_important: 'Cel mai important',
    ranker_title: 'Ce este important pentru tine într-un job ideal?',
    too_insufficient_warning: 'Acest grup conține prea puține afirmații',
    too_much_warning: 'Acest grup conține prea multe afirmații',
    too_much_warning1: 'Ai atribuit prea multe afirmații grupului/grupurilor:',
    too_much_warning2: 'Fă clic pe grup și mută afirmațiile într-un alt grup până când distribuția este corectă',
    empty_bin: 'Acest grup este gol',
    // further_ranking: 'Te rugăm să clasifici suplimentar cele {{v1}} afirmații pe care le-ai marcat ca "{{v2}}"',
    further_ranking: 'Ce este important pentru tine într-un job ideal?',
    hint_modal_title: 'Încearcă să-ți imaginezi mediul de lucru ideal',
    hint_modal_body1: 'Clasifică 42 de afirmații despre mediul tău ideal de la cel mai puțin la cel mai important',
    hint_modal_body2_left: 'stânga',
    hint_modal_body2_left_txt: 'cele 11 afirmații pe care le consideri cel mai puțin importante',
    hint_modal_body2_right: 'dreapta',
    hint_modal_body2_right_txt: 'cele 11 afirmații pe care le consideri cele mai importante',
    hint_modal_body2_middle: 'mijloc',
    hint_modal_body2_middle_txt: 'cele 20 de afirmații pe care le consideri moderat de importante',
    hint_modal_body3: 'Trage și plasează fiecare afirmație în grupul care ți se potrivește cel mai bine',
    hint_modal_cta: 'Pornire',
    hint_top: 'Derulați în sus',
    hint_down: 'Derulați în jos',
    final_distribution_invalid_title: 'Distribuția finală este invalidă',
    final_distribution_invalid_body: 'Există {{v1}} coș(uri) cu prea multe declarații și {{v2}} coș(uri) cu prea puține declarații',
    no_available_bins_warning: 'Niciun coș disponibil pentru atribuire aleatorie - toate coșurile și-au atins capacitatea maximă',
    sort_middle_bucket_title: 'Doriți să sortați coșul din mijloc?',
    sort_middle_bucket_body: 'Acest lucru va sorta coșul din mijloc după valoare.',
    reflect_current_view_title: 'Aceasta reflectă viziunea dvs. actuală?',
    reflect_current_view_sort_body: 'Dacă nu, vi se va oferi să sortați clasamentul final',
    yes: 'Da',
    no: 'Nu',
    final_ranking: 'Clasament final',
    example: 'Exemplu :',
}
